// extracted by mini-css-extract-plugin
export default {"headerWrapper":"single-cube_pages_shared_headerWrapper"};